<script lang="ts">
	import Description from '$lib/components/SEO/Description.svelte';
	import Title from '$lib/components/SEO/Title.svelte';
	import PersonalCredit from '$lib/components/Simulations/Components/Products/PersonalCreditSimulation.svelte';
	import __ from '$lib/stores/TranslationStore';
</script>

<svelte:head>
	<Title content={$__('Simulador de Crédito Pessoal: Calcule a Sua Taxa Instantaneamente')} />
	<Description
		content={$__(
			'Necessita de crédito pessoal? Utilize o nosso simulador para descobrir as melhores taxas disponíveis para si. Simples, rápido e eficaz, o nosso simulador ajuda-o a tomar decisões financeiras informadas com facilidade.'
		)}
	/>
</svelte:head>

<PersonalCredit />
